var defaultModalScrollBarId = 'csg-tw-modal-scroll-bar';

export { defaultModalScrollBarId };
//# sourceMappingURL=default-modal-scroll-bar-id.esm.js.map
